import { ElementType, ReactNode } from "react";

export type TypographyVariant = "display";

type VariantConfig = {
  className: string;
  element: ElementType;
};

const VARIANTS: Record<TypographyVariant, VariantConfig> = {
  display: {
    className: "text-[2.5rem] font-bold tracking-tight text-white",
    element: "h1",
  },
};

type Props = {
  variant?: TypographyVariant;
  as?: ElementType;
  className?: string;
  children: ReactNode;
};

export const Typography = ({
  variant = "display",
  as,
  className,
  children,
}: Props) => {
  const config = VARIANTS[variant];
  const Component = as ?? config.element;

  return (
    <Component className={[config.className, className].filter(Boolean).join(" ")}>
      {children}
    </Component>
  );
};
